import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Error: FC<ISvG> = ({ fill = "#e74c3c" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.367"
      height="20.094"
      viewBox="0 0 23.367 20.094"
    >
      <g transform="translate(0 -35.857)">
        <g transform="translate(0 35.857)">
          <g transform="translate(0 0)">
            <path
              d="M23.066,52.768l-9.585-15.9a2.1,2.1,0,0,0-3.6,0L.3,52.768a2.1,2.1,0,0,0,1.8,3.183h19.17a2.1,2.1,0,0,0,1.8-3.183Zm-1.295,1.368a.579.579,0,0,1-.5.294H2.1a.578.578,0,0,1-.495-.876l9.585-15.9a.578.578,0,0,1,.99,0l9.585,15.9A.579.579,0,0,1,21.771,54.136Z"
              transform="translate(0 -35.857)"
              fill={fill}
            />
          </g>
        </g>
        <g transform="translate(10.66 42.116)">
          <g transform="translate(0 0)">
            <path
              d="M234.608,173.005c-.579,0-1.03.311-1.03.861,0,1.68.2,4.093.2,5.773,0,.438.381.621.833.621.339,0,.819-.183.819-.621,0-1.68.2-4.093.2-5.773A.907.907,0,0,0,234.608,173.005Z"
              transform="translate(-233.578 -173.005)"
              fill={fill}
            />
          </g>
        </g>
        <g transform="translate(10.618 50.345)">
          <path
            d="M233.738,353.306a1.087,1.087,0,0,0,0,2.174,1.087,1.087,0,0,0,0-2.174Z"
            transform="translate(-232.651 -353.306)"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
};

export default memo(Error);
